module.exports = __webpack_public_path__ + "img/logo-choreograph-exact.ecf14639.svg";